import { CustomerFiltersSchema } from 'core/schemas/customerFilters';
import { Customer } from 'core/types/customer';

import usePaginationHandler from './usePaginationHandler';

export default function useCustomers(searchParams: CustomerFiltersSchema) {
  return usePaginationHandler<Customer>('customers', searchParams);
}
